import LocalizationStore from '../Stores/LocalizationStore'
import * as React from 'react'
import ReactTable, { CellInfo } from 'react-table'
import MerchantsStore from '../Stores/MerchantsStore'
import { Link } from 'react-router-dom'
import { Affiliate } from './AffiliateModel'
import Form, { ISubmitEvent, FormValidation, AjvError } from 'react-jsonschema-form'
import UserStore from '../Stores/UserStore'
import HttpActionsService from '../Services/HttpActionsService'
import { Button } from 'react-bootstrap'
import { history } from '../Routing'
import { filterMethod } from '../Helpers/ReactTableHelper'
import ConfigStore from '../Stores/ConfigStore'

const ls = LocalizationStore.getInstance()

export class Merchant {
    id: string
    name: string
    isActive: boolean
    affiliates: Array<Affiliate>
}

export class MerchantTableModel {
    constructor(merchant: Merchant) {
        this.id = merchant.id
        this.name = merchant.name
        this.isActive = merchant.isActive ? ls.t('Active') : ls.t('Not Active')
    }

    id: string
    name: string
    isActive: string
}

export function getMerchantColumns() {
    return [
        {
            Header: ls!.t('id'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'id',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="merchantDetailLink"
                    to={'/merchant/' + cellInfo.row.id}
                    id={cellInfo.row.name}
                >
                    {cellInfo.row.id}
                </Link>
            ),
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'id')
        },
        {
            Header: ls!.t('Name'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'name',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'name')
        },
        {
            Header: ls!.t('isActive'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'isActive',
            filterMethod: (filter: any, row: any) => filterMethod(filter, row, 'isActive')
        }
    ]
}

export function createStub(data: Array<Merchant>) {
    return data.map(x => new MerchantTableModel(x))
}

export function getMerchantsTable() {
    const localizationStore = LocalizationStore.getInstance()
    const merchantsStore = MerchantsStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            data={createStub(merchantsStore.getList)}
            columns={getMerchantColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
        />
    )
}

export function getMerchantFormScheme(merchant: Merchant): any {
    return {
        type: 'object',
        required: [
            'name',
            // 'isActive',
            // 'merchant'
        ],
        properties: {
            id: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            isActive: {
                type: 'boolean',
                title: ls.t('isActive')
            }
        }
    }
}

export function getMerchantFormUIScheme(merchants: Merchant) {
    return {
        'id': {
            'ui:readonly': true,
            'ui:help': ls.t('uneditable'),
        },
    }
}

export function createOrUpdateMerchant(e: ISubmitEvent<any>) {
    var merchant = new Merchant()

    merchant.id = e.formData.id
    merchant.isActive = e.formData.isActive
    merchant.name = e.formData.name

    if (merchant.id) {
        HttpActionsService.getInstance().updateMerchant(merchant)
    } else {
        HttpActionsService.getInstance().createMerchant(merchant)
    }
}

export function validateMerchantForm(formData: any, errors: FormValidation) {
    if (!formData.name) {
        errors.name.addError('Invalid name')
    }
    return errors
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        if (error['params']['type'] === 'number') {
            error['message'] = ls.t('should be number')
        }
        return error
    })
}

export function getMerchantForm() {
    const localizationStore = LocalizationStore.getInstance()
    const userStore = UserStore.getInstance()
    const merchantsStore = MerchantsStore.getInstance()

    let merchant = merchantsStore.getItem

    if (!merchant) {
        return (
            <div>
                <p>{localizationStore.t('no data')}</p>
                <Button
                    onClick={() => { history.push('/merchants') }}
                >
                    {localizationStore!.t!('backToList')}
                </Button>
            </div>
        )
    }

    return (
        <Form
            schema={getMerchantFormScheme(merchant!)}
            uiSchema={getMerchantFormUIScheme(merchant!)}
            onSubmit={(e) => createOrUpdateMerchant(e)}
            formData={merchant}
            validate={validateMerchantForm}
            transformErrors={transformErrors}
        >
            <div className="merchantFormBtns">
                <Button
                    hidden={!(userStore.checkAdmin || userStore.checkSuperAdmin)}
                    type="submit"
                >
                    {localizationStore!.t!('Save')}
                </Button>
                <Button
                    onClick={() => { history.push('/merchants') }}
                >
                    {localizationStore!.t!('backToList')}
                </Button>
            </div>
        </Form>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/MerchantModel.tsx